import { Injectable } from '@angular/core';
import { loadStripe } from '@stripe/stripe-js/pure';
import { Stripe, StripeElements, StripeElementsOptionsClientSecret, TokenCreateParams } from '@stripe/stripe-js/dist';
import { from } from 'rxjs';
import { environment } from '../../environments/environment';
import { UserProfile } from '../models';

@Injectable({
  providedIn: 'root',
})
export class StripeService {
  private stripe: Stripe;

  constructor() {
    loadStripe(environment.STRIPE_PUBLIC_API_KEY)
      .then( (s) => this.stripe = s);
  }

  public createUser(user: Partial<UserProfile>) {
    const payload: TokenCreateParams.Account = {
      business_type: 'individual',
      individual: {
        address: {
          country: user.countryOfResidence,
        },
        first_name: user.firstname,
        last_name: user.lastname,
        dob: {
          day: user.birthday.getDate(),
          month: user.birthday.getMonth() + 1,
          year: user.birthday.getFullYear(),
        },
      },
      tos_shown_and_accepted: true,
    };
    return from(this.stripe.createToken('account', payload));
  }

  public createPaymentElement(options: StripeElementsOptionsClientSecret) {
    return this.stripe.elements(options);
  }

  public confirmPayment(elements: StripeElements, returnUrl: string, purchase: {buyer: {name: string}}) {
    return this.stripe.confirmPayment({
      // `Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        return_url: returnUrl,
        payment_method_data: {
          billing_details: {
            name: purchase.buyer.name,
          },
        },
      },
    });
  }

}
